import { useState } from "react";
import "./PhoneInput.scss";

// Most relevant countries listed first, then alphabetical
const COUNTRIES = [
  { name: "Egypt",                dialCode: "+20",  flag: "🇪🇬" },
  { name: "Saudi Arabia",         dialCode: "+966", flag: "🇸🇦" },
  { name: "UAE",                  dialCode: "+971", flag: "🇦🇪" },
  { name: "Kuwait",               dialCode: "+965", flag: "🇰🇼" },
  { name: "Qatar",                dialCode: "+974", flag: "🇶🇦" },
  { name: "Bahrain",              dialCode: "+973", flag: "🇧🇭" },
  { name: "Oman",                 dialCode: "+968", flag: "🇴🇲" },
  { name: "Jordan",               dialCode: "+962", flag: "🇯🇴" },
  { name: "Lebanon",              dialCode: "+961", flag: "🇱🇧" },
  { name: "Libya",                dialCode: "+218", flag: "🇱🇾" },
  { name: "Morocco",              dialCode: "+212", flag: "🇲🇦" },
  { name: "Tunisia",              dialCode: "+216", flag: "🇹🇳" },
  { name: "Algeria",              dialCode: "+213", flag: "🇩🇿" },
  { name: "Iraq",                 dialCode: "+964", flag: "🇮🇶" },
  { name: "Other Countries",      dialCode: "",     flag: "", disabled: true },
  { name: "Australia",            dialCode: "+61",  flag: "🇦🇺" },
  { name: "Austria",              dialCode: "+43",  flag: "🇦🇹" },
  { name: "Belgium",              dialCode: "+32",  flag: "🇧🇪" },
  { name: "Brazil",               dialCode: "+55",  flag: "🇧🇷" },
  { name: "Canada",               dialCode: "+1",   flag: "🇨🇦" },
  { name: "China",                dialCode: "+86",  flag: "🇨🇳" },
  { name: "Denmark",              dialCode: "+45",  flag: "🇩🇰" },
  { name: "Finland",              dialCode: "+358", flag: "🇫🇮" },
  { name: "France",               dialCode: "+33",  flag: "🇫🇷" },
  { name: "Germany",              dialCode: "+49",  flag: "🇩🇪" },
  { name: "Greece",               dialCode: "+30",  flag: "🇬🇷" },
  { name: "India",                dialCode: "+91",  flag: "🇮🇳" },
  { name: "Ireland",              dialCode: "+353", flag: "🇮🇪" },
  { name: "Italy",                dialCode: "+39",  flag: "🇮🇹" },
  { name: "Japan",                dialCode: "+81",  flag: "🇯🇵" },
  { name: "Netherlands",          dialCode: "+31",  flag: "🇳🇱" },
  { name: "New Zealand",          dialCode: "+64",  flag: "🇳🇿" },
  { name: "Norway",               dialCode: "+47",  flag: "🇳🇴" },
  { name: "Poland",               dialCode: "+48",  flag: "🇵🇱" },
  { name: "Portugal",             dialCode: "+351", flag: "🇵🇹" },
  { name: "Russia",               dialCode: "+7",   flag: "🇷🇺" },
  { name: "South Africa",         dialCode: "+27",  flag: "🇿🇦" },
  { name: "South Korea",          dialCode: "+82",  flag: "🇰🇷" },
  { name: "Spain",                dialCode: "+34",  flag: "🇪🇸" },
  { name: "Sweden",               dialCode: "+46",  flag: "🇸🇪" },
  { name: "Switzerland",          dialCode: "+41",  flag: "🇨🇭" },
  { name: "Turkey",               dialCode: "+90",  flag: "🇹🇷" },
  { name: "United Kingdom",       dialCode: "+44",  flag: "🇬🇧" },
  { name: "United States",        dialCode: "+1",   flag: "🇺🇸" },
];

function PhoneInput({ value, onChange, required, id, placeholder, className }) {
  const [dialCode, setDialCode] = useState("+20");
  const [localNumber, setLocalNumber] = useState("");

  const handleDialCodeChange = (newDialCode) => {
    if (!newDialCode) return; // guard against separator option
    setDialCode(newDialCode);
    const combined = localNumber.trim() ? `${newDialCode} ${localNumber.trim()}` : "";
    onChange(combined);
  };

  const handleLocalChange = (newLocal) => {
    setLocalNumber(newLocal);
    const combined = newLocal.trim() ? `${dialCode} ${newLocal.trim()}` : "";
    onChange(combined);
  };

  // Find the currently selected country flag
  const selectedCountry = COUNTRIES.find((c) => c.dialCode === dialCode && !c.disabled);
  const flag = selectedCountry ? selectedCountry.flag : "";

  return (
    <div className={`phone-input-wrapper${className ? " " + className : ""}`}>
      <div className="dial-code-select-wrapper">
        <span className="dial-flag" aria-hidden="true">{flag}</span>
        <select
          className="dial-code-select"
          value={dialCode}
          onChange={(e) => handleDialCodeChange(e.target.value)}
          aria-label="Country code"
        >
          {COUNTRIES.map((c, i) =>
            c.disabled ? (
              <option key={i} value="" disabled>{c.name}</option>
            ) : (
              <option key={i} value={c.dialCode}>
                {c.flag} {c.name} ({c.dialCode})
              </option>
            )
          )}
        </select>
        <span className="dial-code-display">{dialCode}</span>
        <span className="dial-chevron">▾</span>
      </div>
      <input
        id={id}
        type="tel"
        className="local-number-input"
        value={localNumber}
        onChange={(e) => handleLocalChange(e.target.value)}
        required={required}
        placeholder={placeholder || "Phone number"}
        inputMode="numeric"
        autoComplete="tel-national"
      />
    </div>
  );
}

export default PhoneInput;
